import { useContext } from 'react';

import PresetFormDialog from 'components/Presets/PresetForm/PresetForm';
import { PresetsContext } from 'components/Presets/PresetsContext';
import {
  update,
  grid,
  groupedPresets,
} from 'components/Presets/data/queryKeyFactory';
import { editPreset } from 'components/Presets/sources/presets';

import { useMutation, useQueryClient } from '@gogame/query';
import { useScreenModalV2 } from '@gogame/screens';

export const useUpdatePreset = () => {
  const queryClient = useQueryClient();
  const showModal = useScreenModalV2(PresetFormDialog);
  const { grouped } = useContext(PresetsContext);

  const updateMutation = useMutation(update(), editPreset, {
    successMessage: () => `Preset Update`,
    onMutate: async (changedPreset) => {
      try {
        queryClient.setQueriesData(
          { queryKey: grouped ? groupedPresets({}) : grid({}), exact: false },
          (previousPresets) => {
            if (grouped) {
              return {
                ...previousPresets,
                my: previousPresets?.my.map((group) => ({
                  ...group,
                  children: group.children.map((preset) =>
                    preset.id === changedPreset.id ? changedPreset : preset
                  ),
                })),
              };
            } else {
              return previousPresets?.map((preset) => {
                if (preset.id === changedPreset.id) {
                  return changedPreset;
                }
                return preset;
              });
            }
          }
        );
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log('update preset', e);
      }
    },
  });

  const handleAction = async (preset) => {
    const result = await showModal({
      title: `Update ${preset.isPublic ? 'public' : 'private'} preset ${
        preset.title
      }`,
      initialValues: preset,
    });
    await updateMutation.mutateAsync(result);
  };

  return [handleAction, updateMutation];
};
